import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  updatePassword,
  signOut,
  onAuthStateChanged,
  type User,
  type UserCredential,
} from "firebase/auth";

import { auth } from "./firebase";

// ─────────────────────────────────────────────
// Login
// ─────────────────────────────────────────────
export const loginWithEmail = async (
  email: string,
  password: string,
): Promise<UserCredential> => {
  return await signInWithEmailAndPassword(auth, email, password);
};

// ─────────────────────────────────────────────
// Send reset password email
// ─────────────────────────────────────────────
export const resetPasswordEmail = async (email: string): Promise<void> => {
  return await sendPasswordResetEmail(auth, email);
};

// ─────────────────────────────────────────────
// Change password (for logged-in user)
// ─────────────────────────────────────────────
export const changePassword = async (newPassword: string): Promise<void> => {
  const user = auth.currentUser;

  if (!user) {
    throw new Error("No authenticated user found");
  }

  return await updatePassword(user, newPassword);
};

// ─────────────────────────────────────────────
// Logout
// ─────────────────────────────────────────────
export const logout = async (): Promise<void> => {
  return await signOut(auth);
};

// ─────────────────────────────────────────────
// Auth state listener
// ─────────────────────────────────────────────
export const onAuthChange = (
  callback: (user: User | null) => void,
): (() => void) => {
  return onAuthStateChanged(auth, callback);
};
export type { User, UserCredential };
